export default __webpack_public_path__ + "static/media/weed-leaves-pattern.3ad03df3.jpg";